import { Divider, IconButton } from '@material-ui/core';
import { Field } from 'formik';
import React, { useState, ChangeEvent } from 'react';
import styled from 'styled-components';
import FormikButtonsControl from '../common/FormikButtonsControl';
import { Checkbox } from 'formik-material-ui';

const Container = styled.div`
    width:100%
    padding-left:20px;
    display:grid;
    grid-template-columns:590px 35px;
    align-items:center;
    padding-top:5px;
    
`;

const TextFieldLabel = styled.div`
font-family: Roboto;
font-size: 14px;
font-weight: 400;
`

const FunctionNotificationStep = ({selectedStepId,index,formProps}) => {
    return (
        <>
        <Container  key={index}>
            <TextFieldLabel>
                {formProps.values.workflowSteps.find(ws => ws.id === selectedStepId).notifications[index].name}
            </TextFieldLabel>

            <Field
                component={Checkbox}
                edge="start"
                name={`workflowSteps.${formProps.values.workflowSteps.findIndex(ws => ws.id === selectedStepId)}.notifications.${index}.isNotificationOn`}
                disableRipple
                color="primary"                 
                inputProps={{ 'aria-label': 'primary checkbox' }}
                type="checkbox"
            />

        </Container>
        <div style={{paddingTop:1}}/>
        </>                   
    )
}

export default FunctionNotificationStep;